import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPasswordService } from '../../services/account/forgot-password.service';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    providers: [ForgotPasswordService]
})

export class ForgotPasswordComponent {
    email: string;
    isConfirmed: boolean = false;
    constructor(private forgotPasswordService: ForgotPasswordService) {
    }

    public buttonClick() {
        let that = this;
        this.forgotPasswordService.post(this.email).subscribe(
            response => {
                that.isConfirmed = true;
            });
    }
}